import React from 'react'
import PropTypes from 'prop-types'

import AccountsAccessFieldRow from '../../../../reusableFormFields/AccountsAccessFieldRow'
import BrandCategoryFieldRow from '../../../../reusableFormFields/BrandCategoryFieldRow'
import MediaSubCategoriesFieldRow from '../../../../reusableFormFields/MediaSubCategoriesFieldRow'

import { getAllowSelfAccounts, getShowBrandCategorySelect, getShowMediaSubCategories } from '../../../../helpers'

const ControllerMemberContentReusableFields = ({ formik, controllerMemberRole, showClearBrandCategory }) => {
  const allowSelfAccounts = getAllowSelfAccounts(controllerMemberRole)
  const showBrandCategorySelect = getShowBrandCategorySelect(controllerMemberRole)
  const showMediaSubCategories = getShowMediaSubCategories(controllerMemberRole)

  return (
    <>
      {allowSelfAccounts && <AccountsAccessFieldRow formik={formik} />}
      {showBrandCategorySelect && <BrandCategoryFieldRow formik={formik} showClearInputIcon={showClearBrandCategory} />}
      {showMediaSubCategories && <MediaSubCategoriesFieldRow formik={formik} />}
    </>
  )
}

ControllerMemberContentReusableFields.propTypes = {
  formik: PropTypes.object.isRequired,
  controllerMemberRole: PropTypes.string.isRequired,
  showClearBrandCategory: PropTypes.bool
}

export default ControllerMemberContentReusableFields
